module.exports = "/images/procedures.2e08848ec080294a0212388282306d58.svg";